import styled, { keyframes } from 'styled-components';
import { Animation } from 'ui/styled';

export const DashboardTitle = styled.div.attrs({})`
  font-size: 22px;
  font-weight: bold;
  color: ${(props) => props.theme.palette.colors.black};
  margin-bottom: 12px;
  ${(props) => (props.centred ? `   text-align: center; ` : ``)}
`;

export const DashboardText = styled.div.attrs({})`
  font-size: 16px;
  line-height: 26px;
  color: ${(props) => props.theme.palette.colors.black};
  ${(props) => (props.centred ? ` text-align: center; ` : ``)}
`;

export const DashboardAnimation = styled(Animation).attrs({
  width: '100%',
  height: 420,
})``;

export const HomeImage = styled.div.attrs({})`
  background:
    linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${(props) => props.src}) no-repeat center/cover;
  border-radius: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 16 / 9;
`;

export const BodyContainer = styled.div.attrs({})`
  width: 100%;
  height: 100%;
`;

export const FullscreenButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
  border: none;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition:
    transform 0.3s ease,
    background-color 0.3s ease;
  backdrop-filter: blur(5px);
  &:hover {
    background-color: rgba(255, 255, 255, 1);
    transform: scale(1.1);
  }
  &:active {
    transform: scale(0.95);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  svg {
    color: #333;
    transition: color 0.3s ease;
  }
`;

export const DashboardVideo = styled.video.attrs(() => ({
  loop: true,
  muted: true,
  controls: true,
  autoplay: true,
}))`
  width: 100%;
  max-height: 80lvh;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  object-fit: cover;
`;

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

export const LogoSpinner = styled.img`
  display: block;
  position: absolute;
  width: 32vw; /* Aumente este valor (exemplo: de 29vw para 32vw) */
  height: 32vw; /* Aumente este valor */
  max-width: 500px; /* Aumente este valor (exemplo: de 470px para 500px) */
  max-height: 500px; /* Aumente este valor */
  min-width: 150px;
  min-height: 150px;
  object-fit: contain;
  border-radius: 50%;
  animation: ${spin} 6s linear infinite;
  z-index: 1;
  @media (max-width: 768px) {
    width: 50vw; /* Ajuste aqui também se necessário */
    height: 50vw; /* Ajuste aqui também se necessário */
  }
`;
